import { axiosInstance } from "../lib/axios";

class EnrollmentServiceClient {
  BASE_URL = "/enrollments";
  async listEnrollments(params) {
    const { data } = await axiosInstance.get(this.BASE_URL, { params });
    return data;
  }

  async getEnrollmentById(id) {
    const { data } = await axiosInstance.get(`${this.BASE_URL}/${id}`);
    return data;
  }

  async onboardEnrollment(id) {
    const { data } = await axiosInstance.post(`${this.BASE_URL}/${id}/onboard`);
    return data;
  }

  async bulkEnrollMembers({
    partnerId,
    membershipTypeId,
    courseId,
    courseIds,
    file,
  }) {
    const fd = new FormData();
    fd.append("partnerId", partnerId);
    fd.append("membershipTypeId", membershipTypeId);
    if (Array.isArray(courseIds) && courseIds.length) {
      courseIds.forEach((id) => fd.append("courseIds", id));
    } else if (courseId) {
      fd.append("courseId", courseId);
    }
    fd.append("file", file);

    const { data } = await axiosInstance.post(
      `${this.BASE_URL}/bulk-enroll`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  }

  async resendOnboardingEmail(userId) {
    const { data } = await axiosInstance.post(
      `${this.BASE_URL}/resend-onboarding-email`,
      { userId },
    );
    return data;
  }

  async resendSelfOnboardingEmail(userId) {
    const { data } = await axiosInstance.post(
      `${this.BASE_URL}/resend-self-onboarding-email`,
      { userId },
    );
    return data;
  }
}

export const enrollmentServiceClient = new EnrollmentServiceClient();
export default EnrollmentServiceClient;
